import { render, staticRenderFns } from "./FundingDetails.vue?vue&type=template&id=6636084f&scoped=true&"
import script from "./FundingDetails.vue?vue&type=script&lang=js&"
export * from "./FundingDetails.vue?vue&type=script&lang=js&"
import style0 from "./FundingDetails.vue?vue&type=style&index=0&id=6636084f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6636084f",
  null
  
)

export default component.exports